import React, { useEffect } from "react";
import { connect } from "react-redux";
import * as layoutService from "../view/layoutService";
import { useHistory } from "react-router-dom";
import { withMainLayout } from "../view/LayoutHOCs";
import { TablesSection } from "./TablesSection";
// import { AlertAccountSettings } from "./AlertAccountSettings";
import { InfoBoxes } from "../info-boxes/InfoBoxes";

const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "Alert Notifications",
        redirectTo: "/alert-notifications",
    }
]

function AlertNotificationPage({ userCapability }) {

    const history = useHistory();

    useEffect(() => {
        layoutService.setPageTitle('Alert Notifications')
        layoutService.setBreadcrumbs(breadcrumbs)
    }, [history.location])

    //Hide pages with capability = -1, and even if the url is copied then logout the user directly
    //#region Set User Capabilities
    const checkAlertNotificationCapability = async () => {
        if (userCapability) {
            const capability = userCapability.find(item =>
                item.component === "alertnotification" && item.type === "page")?.permission;
            if (capability === -1) {
                sessionStorage.removeItem('access_token');
                window.location.reload();
            }
        }
    };

    useEffect(() => {
        checkAlertNotificationCapability();
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);
    //#endregion

    return (
        <div className="alert-notifications-page">
            <InfoBoxes />
            {/* <AlertAccountSettings /> */}
            <TablesSection />
        </div>
    )

}

function mapStateToProps(state) {
    const auth = state.auth;
    return {
        userCapability: auth.userCapability,
    }
}

export default withMainLayout(connect(mapStateToProps)(AlertNotificationPage));
